import {
	Button,
	Divider,
	List,
	ListItem,
	ListItemText,
	Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import config from "react-global-configuration";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";
import Carregando from "../../Pagina/Carregando";

const Duplicar = (props) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [loading, SetLoading] = useState(false);
	const [models, SetModels] = useState();
	const [lista, SetLista] = useState();

	const getModels = () => {
		SetLoading(true);
		fetch(
			config.get("url_api") + "orcamento/listar-duplicar/" + props.negocioId,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json;charset=utf-8",
				},
			}
		)
			.then((res) => res.json())
			.then(
				(result) => {
					SetLoading(false);
					SetModels(result.modelos);
				},
				(error) => {
					SetLoading(false);
					alert(error);
				}
			);
	};

	const loadModels = () => {
		if (!models) {
			getModels();
		}
		SetModalOpen(true);
	};

	return (
		<React.Fragment>
			{modalOpen && (
				<Backdrop>
					<Modal
						title="Copiar de"
						onCancel={() => {
							SetModalOpen(false);
						}}
						onConfirmLabel="Copiar do orçamento"
						size="lg"
						onCancelTopo
					>
						{loading && <Carregando />}
						{!loading && models && models.length > 0 && (
							<React.Fragment>
								<Typography>
									Aqui você pode copiar algum dos orçamentos já criados para
									este negócio.
								</Typography>
								<List className="modelsList h-100">
									{models.map((model) => (
										<React.Fragment key={model.id}>
											<ListItem
												button
												onClick={() => {
													props.carregarModelo(model.json);
													SetModalOpen(false);
												}}
											>
												<ListItemText
													primary={model.nome}
													// secondary={1 == 1 ? "Secondary text" : null}
												/>
											</ListItem>
											<Divider />
										</React.Fragment>
									))}
								</List>
							</React.Fragment>
						)}
					</Modal>
				</Backdrop>
			)}
			<Button
				onClick={() => loadModels()}
				variant="contained"
				color="primary"
				size="small"
				className="ml-1"
			>
				Copiar de
			</Button>
		</React.Fragment>
	);
};

export default Duplicar;
